import React from 'react';
import { EditButton } from '@Components/controls/Button/Button';
import {
	EditIcon,
	EditItemlink,
	EditLinkWrapper,
} from '@Components/Card/cards/ContactDisplayDetails/ContactDisplayDetails.styled';
import useTranslate from '@Utils/hooks/useTranslate';

export interface IEditCTA {
	onClick: (e?: any) => void;
	uniqueId: string;
}

const EditCTA = ({ onClick, uniqueId }: IEditCTA): JSX.Element => {
	const { translate } = useTranslate();

	return (
		<EditButton onClick={onClick} uniqueId={uniqueId}>
			<EditLinkWrapper>
				<EditIcon name="edit" fill="white" />
				<EditItemlink>{translate('secure-checkout.edit-cta')}</EditItemlink>
			</EditLinkWrapper>
		</EditButton>
	);
};

export default EditCTA;
